import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import "./index.scss";
import Resizer from "react-image-file-resizer";

import addImage from "../../../assets/images/add_image.png";
import values from "../../values";

import { GET_FILE } from "../../api/routes";

type Props = {
  uploadImage: any;
  defaultImage: any;
  setImage: (file: any) => void;
  label?: string;
  onRemoveImage?: (image: string) => void;
};

const resizeFile = (file: File) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const ImageUploader: React.FC<Props> = ({
  uploadImage,
  defaultImage,
  setImage,
  label = "انتخاب عکس",
  onRemoveImage,
}) => {
  const [selectedFile, setFile] = useState<File | null>(null);
  const [resizedImage, setResizedImage] = useState<any>(null);

  function removeImage(image: string) {
    if (onRemoveImage) onRemoveImage(image);
    else {
      setImage(null);
      setResizedImage(null);
    }
  }

  // console.log(image);
  const LoadSelectedImage = ({ image }: any) => {
    if (!image?.link) return <></>;
    return (
      <div className="new-image">
        <i
          onClick={() => removeImage(image?.link)}
          className="fa-solid fa-xmark"
        ></i>
        <img src={image?.link} alt="property_image" className="add-new-image" />
      </div>
    );
  };

  const uploadImageFile = async (file: any) => {
    if (!file) return;

    // if (resizedImage && resizedImage.isUpload) return;

    const image: any = await resizeFile(file);
    setResizedImage({ img: image, isUpload: false });

    console.log(uploadImage);
    uploadImage(image)?.then((res: any) => {
      res?.result && setImage(res?.result);
    });
    setResizedImage((prevState: any) => {
      if (prevState.img === image) {
        prevState.isUpload = true;
      }
      return prevState;
    });
  };

  const onDrop = (acceptedFiles: File[]) => {
    setFile(acceptedFiles[0]);
  };

  useEffect(() => {
    uploadImageFile(selectedFile);
  }, [selectedFile]);

  // useEffect(() => {
  //   setFile(defaultImage?.link);
  // }, [defaultImage?.link]);
  return (
    <section id="image-uploader-container">
      <label className="upload-label">{label}</label>
      <div className="thumbnail">
        {defaultImage?.link ? (
          <section className="uploaded-image">
            <LoadSelectedImage image={defaultImage} />
            <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  {/* <div className="image">
                    <img src={addImage} alt="Arash_Add_Image" className="default-image" />
                  </div> */}
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </section>
        ) : (
          <section className="select-image">
            <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  {/* <section className="upload-first-image-zone"> */}
                  <div className="first-image">
                    <img
                      src={addImage}
                      alt="Arash_Add_Image"
                      className="default-image"
                    />
                  </div>
                  {/* </section> */}
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </section>
        )}
      </div>
    </section>
  );
};

export default ImageUploader;
